import Typed from "typed.js"

const priceSwitchers = document.querySelectorAll("[data-price-swicher]")
priceSwitchers.forEach(e => {
    const btns = e.children
    for (let btn of btns) {
        btn.addEventListener("click", event => {
            if (event.target.classList.contains("active")) return
            event.target.parentNode.querySelector(".active").classList.remove("active")
            event.target.classList.add("active")
            const price = event.target.parentNode.parentNode.querySelector(".value")
            let priceValue = price.getAttribute("data-price-year")
            let tariffId = event.target.getAttribute("data-tariff-id")
            const targetPeriod = event.target.getAttribute("data-period-text")
            const period = event.target.parentNode.parentNode.querySelector(".period")
            if (event.target.getAttribute("data-price-by-half-year")) {
                priceValue = price.getAttribute("data-price-half-year")
            }
            if (event.target.getAttribute("data-price-by-month")) {
                priceValue = price.getAttribute("data-price-month")
            }
            const buttons = event.target
                .closest("[data-price-tariff-item]")
                .querySelectorAll("[data-default-auth-handler]")
            if (buttons) {
                buttons.forEach(btn => {
                    btn.dataset.tariffId = tariffId
                })
            }
            price.innerHTML = priceValue
            period.innerHTML = targetPeriod
        })
    }
})

const additionnalPriceInfoButton = document.querySelector("[data-show-price-info]")
additionnalPriceInfoButton?.addEventListener("click", () => {
    const additionnalPriceInfoBody = document.querySelector("[data-show-price-body]")
    if (!additionnalPriceInfoBody.classList.contains("show")) {
        window.scrollTo({
            top:
                document.querySelector(".price-scroll").getBoundingClientRect().top +
                window.scrollY -
                document.querySelector("header").offsetHeight,
            behavior: "smooth"
        })
    }
    additionnalPriceInfoBody.classList.toggle("show")
})

const tariffLinks = document.querySelectorAll("[data-price-tariff-link]")
const priceOverlay = document.querySelector(".price-overlay")
priceOverlay?.addEventListener("click", e => {
    e.target.classList.remove("show")
    const tariffsBlocks = document.querySelectorAll("[data-price-tariff-item]")
    tariffsBlocks.forEach(b => {
        b.classList.remove("show")
    })
})
tariffLinks?.forEach(tariffLink => {
    tariffLink.addEventListener("click", e => {
        e.target.closest("[data-price-tariff-item]").classList.toggle("show")
        document.querySelector(".price-overlay").classList.toggle("show")
    })
})

const priceTableLinks = document.querySelectorAll("[data-price-table-link]")
priceTableLinks?.forEach(e => {
    e.addEventListener("click", e => {
        e.target.closest(".pricing__text__price_table").classList.toggle("open-table")
    })
})
document.querySelector("[data-show-more-options]")?.addEventListener("click", () => {
    document.querySelector("[data-show-more-options]").remove()
    document.querySelector("[data-more-options]").classList.remove("d-none")
})
const tooltips = document.querySelectorAll(".tooltip__handler")
tooltips?.forEach(e => {
    const cross = e.closest(".tooltip").querySelector(".tooltip__body_cross")
    if (cross) {
        cross.addEventListener("click", i => {
            console.log(i)
            i.target.closest(".tooltip").querySelector(".tooltip__body").classList.remove("show")
        })
    }
    e.addEventListener("click", i => {
        i.target.closest(".tooltip").querySelector(".tooltip__body").classList.toggle("show")
    })
})
function tooltipClickOutside() {
    const tooltips = document.querySelectorAll(".tooltip")
    if (tooltips) {
        tooltips.forEach(tolltip => {
            const isClickInside = tolltip.contains(event.target)
            if (!isClickInside) {
                const tooltipBody = tolltip.querySelector(".tooltip__body")
                if (tooltipBody) {
                    tooltipBody.classList.remove("show")
                }
            }
        })
    }
}
document.body.addEventListener("mousedown", tooltipClickOutside)
document.body.addEventListener("touchstart", tooltipClickOutside)
const header = document.querySelector("header")
if (header.classList.contains("header_change_color")) {
    document.addEventListener("scroll", () => {
        const changeBlock = document.querySelector(".pricing__lms").getBoundingClientRect().top
        if (changeBlock > 0) {
            document.querySelector("header").classList.add("header_green")
        } else {
            document.querySelector("header").classList.remove("header_green")
        }
    })
}
const flipBlocks = document.querySelector(".flip_blocks")
if (flipBlocks) {
    setInterval(() => {
        let LastBlock = flipBlocks.children[flipBlocks.children.length - 1]
        let LastBlockClone = LastBlock.cloneNode(true)
        flipBlocks.children[1].classList.remove("active")
        if (LastBlock) {
            flipBlocks.prepend(LastBlockClone)
            flipBlocks.children[1].classList.add("active")
            LastBlock.remove()
        }
    }, 3000)
}

const typed = document.querySelector("#typed_domain")
let options = {
    strings: ["domain", "businessschool", "onlineschool"],
    typeSpeed: 75,
    backSpeed: 50,
    backDelay: 800,
    startDelay: 500,
    loop: true,
    showCursor: false,
    attr: null
}
if (typed) {
    new Typed("#typed_domain", options)
}

const typedWebinar = document.querySelector("#search-types-webinar")
if (typedWebinar) {
    const contentTypedLoading = document.querySelector("#webinar-type-loading")
    const contentWebinarItems = document.querySelector(".webinar-items")
    const contentTypedDesign = document.querySelectorAll(".webinar-type-0")
    const contentTypedWebinar = document.querySelectorAll(".webinar-type-1")

    const detectChange = (types, val = "") => {
        for (let i = 0; i < types.length; i++) {
            const type = types[i]
            type.style.display = val
        }
    }

    new Typed("#search-types-webinar", {
        ...options,
        strings: ["Design ux", "Webinar how to"],
        backDelay: 2500,
        preStringTyped: function () {
            detectChange([contentTypedLoading], "block")
            detectChange([contentWebinarItems], "none")
            detectChange(contentTypedDesign)
            detectChange(contentTypedWebinar)
        },
        onStringTyped: function (pos) {
            detectChange([contentTypedLoading])
            detectChange(pos === 0 ? contentTypedDesign : contentTypedWebinar, "block")
            detectChange([contentWebinarItems], "flex")
        }
    })
}
const webinarTimerEl = document.querySelector("#webinar-timer-value")
if (webinarTimerEl) {
    const getTimeRemaining = endtime => {
        const t = Date.parse(endtime) - Date.parse(new Date())
        const seconds = Math.floor((t / 1000) % 60)
        const minutes = Math.floor((t / 1000 / 60) % 60)
        const hours = Math.floor((t / (1000 * 60 * 60)) % 24)
        const days = Math.floor(t / (1000 * 60 * 60 * 24))
        return {
            total: t,
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds
        }
    }

    let timeinterval
    const updateClock = endtime => {
        const t = getTimeRemaining(endtime)
        const parseTime = val => ("0" + val).slice(-2)
        const time = `${parseTime(t.hours)}:${parseTime(t.minutes)}:${parseTime(t.seconds)}`
        webinarTimerEl.innerHTML = time

        if (t.total <= 0) {
            clearInterval(timeinterval)
        }
    }
    // eslint-disable-next-line no-unused-vars
    const initializeClock = endtime => {
        updateClock(endtime)
        timeinterval = setInterval(updateClock, 1000, endtime)
    }
    const date = new Date()
    date.setHours(date.getHours() + 11, 34, 11)
    initializeClock(date)
}
window.isInViewport = function isInViewport(el) {
    const rect = el.getBoundingClientRect()
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    )
}
const linquisticTimer = document.querySelector(".linguistic__upsell_loader")
function startProgress() {
    let linquistictimeinterval
    let linquisticProgress = 0
    linquistictimeinterval = setInterval(() => {
        linquisticProgress++
        linquisticTimer.querySelector(".percent").innerHTML = linquisticProgress
        if (linquisticProgress === 100) {
            linquisticTimer.remove()
            clearInterval(linquistictimeinterval)
        }
    }, 100)
}
if (linquisticTimer) {
    let started = false

    document.addEventListener("scroll", () => {
        if (window.isInViewport(linquisticTimer)) {
            if (!started) {
                started = true
                startProgress()
            }
        }
    })
}
const tarifCalculate = document.querySelectorAll("[data-tarif-calculate]")
tarifCalculate.forEach(e => {
    const tariff = e.closest(".pricing__lms__tariffs_item")
    let price = tariff.querySelector(".pricing__lms__tariffs_item_price_item span")
    let priceMonth = price.getAttribute("data-price-month").replace("$", "")
    let priceYear = price.getAttribute("data-price-year").replace("$", "")
    let priceHalfYear = price.getAttribute("data-price-half-year").replace("$", "")

    e.addEventListener("click", event => {
        if (e.classList.contains("disabled")) {
            event.preventDefault()
        }
        let value = tariff.querySelector(".pricing__lms__tariffs_item_btn").getAttribute("data-tariff-number")
        let currentPrice = price.innerHTML.replace("$", "") / value
        const operation = e.getAttribute("data-tarif-calculate")
        if (operation === "plus") {
            value++
            tariff.querySelector(".pricing__lms__tariffs_item_calculate_actions_btn_minus").classList.remove("disabled")
        }
        if (operation === "minus" && value != 1) {
            --value
        }
        if (value === 1) {
            tariff.querySelector(".pricing__lms__tariffs_item_calculate_actions_btn_minus").classList.add("disabled")
        }
        const buttons = tariff.querySelectorAll(".pricing__lms__tariffs_item_btn")
        buttons.forEach(btn => {
            btn.setAttribute("data-tariff-number", value)
        })

        price.setAttribute("data-price-month", `$${priceMonth * value}`)
        price.setAttribute("data-price-year", `$${priceYear * value}`)
        price.setAttribute("data-price-half-year", `$${priceHalfYear * value}`)
        price.innerHTML = `$${currentPrice * value}`
        tariff.querySelector(".pricing__lms__tariffs_item_calculate_text_number").innerHTML = value
        tariff.querySelectorAll("[data-default-count]").forEach(item => {
            let itemcount = item.getAttribute("data-default-count")
            let resValue = itemcount * value
            if (item.classList.contains("with-comma")) {
                itemcount = itemcount.replace(",", "")
                resValue = itemcount * value
                resValue = resValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }

            item.innerHTML = resValue
        })
    })
})
